export default class DataForChart {
    constructor() {
        this.header = [];
        this.rowls = [];

        this.addColumn = this.addColumn.bind(this);
        this.getChartData = this.getChartData.bind(this);
    }

    addColumn() {
        // console.log('Want to add new col!');
        // console.log(arguments);

        if (arguments.length === 2) {
            const first = arguments[0];
            const second = arguments[1];

            // console.log(first + ' ' + second);
            const col = { type: first, label: second };
            this.header.push(col);
        }
        if (arguments.length === 1) {
            this.header.push(arguments[0]);
        }
    }

    addRow() {
        const rowObject = [];
        for (let i = 0; i < arguments.length; i++) {
            const valObject = { v: arguments[i] };
            rowObject.push(valObject);
        }
        const toPush = { c: rowObject };
        this.rowls.push(toPush);
    }

    getChartData() {
        return {
            cols: this.header,
            rows: this.rowls
        };
    }
}
